import React from 'react';
import { Header } from '../../types';
import './JobsHeader.scss';

export interface JobsHeaderProps {
  headers: Header[];
}

export const JobsHeader: React.FC<JobsHeaderProps> = ({ headers }) => (
  <div className="jobs-list-header">
    {headers.map(({ title, span = 1 }) => (
      <div data-span={span} className="jobs-list-header__item">
        {title}
      </div>
    ))}
  </div>
);
